module.exports = __webpack_public_path__ + "img/vietqr_logo.5c09c899.png";